import { AITRADE } from '@/assets/svg/mine/AITRADE';
import { BANK } from '@/assets/svg/mine/BANK';
import { BUSINESSRECHARGE } from '@/assets/svg/mine/BUSINESSRECHARGE';
import { CHANGEPASSWORD } from '@/assets/svg/mine/CHANGEPASSWORD';
import { CHANGEPAYMENTPASSWORD } from '@/assets/svg/mine/CHANGEPAYMENTPASSWORD';
import { MESSAGE } from '@/assets/svg/mine/MESSAGE';
import { VERIFIED } from '@/assets/svg/mine/VERIFIED';
import { WITHDRAW } from '@/assets/svg/mine/WITHDRAW';
import PageEnum from '@/enums/pageEnum';
import { useModel } from '@umijs/max';
import { useTranslation } from 'react-i18next';

export enum VerifiedStatesEnum {
  //未实名
  UNREAL = 0,
  //审核中
  UNDER = 1,
  //已实名
  REAL = 2,
}

export default function useStateHooks() {
  const { t } = useTranslation();
  const { user } = useModel('user');
  const { getShowMenuList } = useModel('appInfo');

  const cards = getShowMenuList([
    // {
    //   key: t('返佣'),
    //   icon: <INVITE  className='text-auxiliaryTextColor'/>,
    //   path: PageEnum.INVITE,
    // },
    {
      key: t('充值'),
      icon: <BUSINESSRECHARGE className="text-auxiliaryTextColor" />,
      path: PageEnum.BUSINESSRECHARGE,
    },
    {
      key: t('提现'),
      icon: <WITHDRAW className="text-auxiliaryTextColor" />,
      path: PageEnum.WITHDRAW,
    },
    {
      key: t('AI交易'),
      icon: <AITRADE className="text-auxiliaryTextColor" />,
      path: PageEnum.AITRADE,
    },
    {
      key: t('钱包'),
      icon: <BANK className="text-auxiliaryTextColor" />,
      path: PageEnum.BANK,
    },


    {
      key: t('消息通知'),
      icon: <MESSAGE className="text-auxiliaryTextColor" />,
      path: PageEnum.MESSAGE,
    },
    {
      key: t('支付密码'),
      icon: <CHANGEPAYMENTPASSWORD className="text-auxiliaryTextColor" />,
      path: PageEnum.CHANGEPAYMENTPASSWORD,
    },
    {
      key: t('登录密码'),
      icon: <CHANGEPASSWORD className="text-auxiliaryTextColor" />,
      path: PageEnum.CHANGEPASSWORD,
    },
  ]);
  // 判断是否已经实名
  if (user?.realnameStatus !== VerifiedStatesEnum.REAL) {
    cards.splice(cards.length - 1, 0, {
      key: t('实名认证'),
      icon: <VERIFIED className="text-auxiliaryTextColor" />,
      path: PageEnum.VERIFIED,
    });
  }

  return {
    t,
    cards,
    user,
  };
}
export type mineStateType = ReturnType<typeof useStateHooks>;
